import moment from 'moment';
import { EN, SupportedLocale } from '../../../core/util/localizedStr';
import { capitalize } from '../../../core/util/string';

const formatMonth = (m: any, f = 'MM', locale: SupportedLocale = EN) =>
  moment().locale(locale).month(m).format(f);

const getMonths = (locale: SupportedLocale = EN) => {
  // @ts-expect-error ts-migrate(2345) FIXME: Type '{ length: number; }' is missing the followin... Remove this comment to see the full error message
  const monthOptions = Array.apply(null, { length: 12 }).map((_, i) => ({
    key: i,
    value: formatMonth(i, 'MMMM', EN),
    label: capitalize(formatMonth(i, 'MMMM', locale), { locale }),
  }));
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number'.
  monthOptions.unshift({ key: 'default', value: '', label: '' });
  return monthOptions;
};

const getDays = () => {
  // @ts-expect-error ts-migrate(2345) FIXME: Type '{ length: number; }' is missing the followin... Remove this comment to see the full error message
  const daysOptions = Array.apply(null, { length: 31 }).map((_, i) => ({
    key: i + 1,
    value: i + 1,
    label: i + 1,
  }));
  // @ts-expect-error ts-migrate(2322) FIXME: Type 'string' is not assignable to type 'number'.
  daysOptions.unshift({ key: 'default', value: '', label: '' });
  return daysOptions;
};

export { formatMonth, getDays, getMonths };
